import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=50eb94ef&"
import script from "./TextArea.vue?vue&type=script&lang=js&"
export * from "./TextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports